<template>
<!-- Created with Inkscape (http://www.inkscape.org/) -->

<svg
   version="1.1"
   id="svg249"
   xml:space="preserve"
   width="682.66669"
   height="682.66669"
   viewBox="0 0 682.66669 682.66669"
   xmlns="http://www.w3.org/2000/svg"
   xmlns:svg="http://www.w3.org/2000/svg"><defs
     id="defs253"><clipPath
       clipPathUnits="userSpaceOnUse"
       id="clipPath271"><path
         d="M 0,512 H 512 V 0 H 0 Z"
         id="path269" /></clipPath></defs><g
     id="g255"
     transform="matrix(1.3333333,0,0,-1.3333333,0,682.66667)"><g
       id="g257"
       transform="translate(361.9167,267.0001)"><path
         d="M 0,0 V 147"
         style="fill:none;stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
         id="path259" /></g><g
       id="g261"
       transform="translate(214.4629,50)"><path
         d="M 0,0 H 99.037"
         style="fill:none;stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
         id="path263" /></g><g
       id="g265"><g
         id="g267"
         clip-path="url(#clipPath271)"><g
           id="g273"
           transform="translate(273.9167,502)"><path
             d="m 0,0 h -243.917 c -11.045,0 -20,-8.954 -20,-20 v -412 c 0,-11.046 8.955,-20 20,-20 h 50 44.464"
             style="fill:none;stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path275" /></g><g
           id="g277"
           transform="translate(361.9167,414)"><path
             d="M 0,0 -88,88 V 18.624 C -88,8.338 -79.662,0 -69.376,0 Z"
             style="fill:none;stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path279" /></g><g
           id="g281"
           transform="translate(293.9583,340.0297)"><path
             d="M 0,0 H -58.458"
             style="fill:none;stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path283" /></g><g
           id="g285"
           transform="translate(235.5,396.0198)"><path
             d="M 0,0 V 0"
             style="fill:none;stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path287" /></g><g
           id="g289"
           transform="translate(293.9583,284.0099)"><path
             d="M 0,0 H -58.458"
             style="fill:none;stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path291" /></g><g
           id="g293"
           transform="translate(273.9167,228.0198)"><path
             d="M 0,0 H -202.907"
             style="fill:none;stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path295" /></g><g
           id="g297"
           transform="translate(273.9167,172)"><path
             d="M 0,0 H -55.477"
             style="fill:none;stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path299" /></g><g
           id="g301"
           transform="translate(166.7903,172)"><path
             d="M 0,0 H -95.78"
             style="fill:none;stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path303" /></g><g
           id="g305"
           transform="translate(128,115.9802)"><path
             d="M 0,0 H -56.99"
             style="fill:none;stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path307" /></g><g
           id="g309"
           transform="translate(389.9957,274)"><path
             d="m 0,0 112.004,-34.968 v -93.531 c 0,-66.184 -46.998,-123.044 -112,-135.501 v 0 0 c -65.001,12.457 -112,69.317 -112,135.501 v 93.531 L 0.009,0"
             style="fill:none;stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path311" /></g><g
           id="g313"
           transform="translate(318,209.6157)"><path
             d="m 0,0 v -64.114 c 0,-44.326 29.847,-82.89 72,-94.465 42.153,11.575 72,50.139 72,94.465 V 0 L 72,22.479 Z"
             style="fill:none;stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path315" /></g><path
           d="m 191.01,284.01 h -120 v 120 h 120 z"
           style="fill:none;stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
           id="path317" /><g
           id="g319"
           transform="translate(135.4099,339.6099)"><path
             d="m 0,0 h -8.8 c -30.707,0 -55.6,-24.893 -55.6,-55.6 v 0 h 120 v 0 C 55.6,-24.893 30.707,0 0,0 Z"
             style="fill:none;stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path321" /></g><g
           id="g323"
           transform="translate(131.0099,388.0099)"><path
             d="m 0,0 v 0 c -12.15,0 -22,-9.85 -22,-22 v -4.4 c 0,-12.15 9.85,-22 22,-22 v 0 c 12.15,0 22,9.85 22,22 V -22 C 22,-9.85 12.15,0 0,0 Z"
             style="fill:none;stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path325" /></g><g
           id="g327"
           transform="translate(390,104)"><path
             d="M 0,0 V 62"
             style="fill:none;stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path329" /></g><g
           id="g331"
           transform="translate(370.1073,155.5)"><path
             d="M 0,0 19.893,19.726 39.785,0"
             style="fill:none;stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path333" /></g><g
           id="g335"
           transform="translate(169.4633,50)"><path
             d="M 0,0 V 0"
             style="fill:none;stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path337" /></g></g></g></g></svg>
</template>
